import { render, staticRenderFns } from "./SpriteLabel.vue?vue&type=template&id=1fbe414d&"
import script from "./SpriteLabel.vue?vue&type=script&lang=js&"
export * from "./SpriteLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports